export const Role = {
    Admin: 'Administrator',
    Manager: 'Manager',
    Blogger: 'Blogger',
    Office: 'Office',
    Foreman: 'Foreman',
    User: 'User'
}